import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Tooltip from '../Tooltip';
import ColorsHelper from '../../helpers/colorsHelper';
import makeTooltipText from './helpers/tooltipColorText';

const colors = ColorsHelper.colors.list;

function Color({
  color = null, highlight, highlightAnimationReset, colorAt = null, colorBy = null,
}) {
  const customLabels = useSelector((state) => state.user?.team?.settings?.colorLabels || {});
  const selectedColor = useMemo(
    () => colors.find((colorItem) => colorItem.value === color) || {},
    [color],
  );

  const tooltipText = useMemo(
    () => {
      const text = customLabels[selectedColor.value] || selectedColor.title || '';
      return makeTooltipText(text, colorAt, colorBy);
    },
    [customLabels, selectedColor.value, selectedColor.title, colorAt, colorBy],
  );

  return (
    <Tooltip content={tooltipText} placement="top">
      <div
        className={cn('catalogItem__color', {
          showColorCatalogItem: color !== 'nocolor',
          highlightBlink: highlight,
        })}
        style={{ background: selectedColor.background }}
        onAnimationEnd={() => highlightAnimationReset('color')}
      />
    </Tooltip>
  );
}

Color.propTypes = {
  color: PropTypes.string,
  highlight: PropTypes.bool.isRequired,
  highlightAnimationReset: PropTypes.func.isRequired,
  colorAt: PropTypes.string,
  colorBy: PropTypes.shape({
    _id: PropTypes.string,
    displayName: PropTypes.string,
    email: PropTypes.string,
  }),
};

export default memo(Color);
